import React, { useState, useEffect } from "react";
import "./App.css";
import {
  FaInstagram,
  FaYoutube,
  FaPhoneAlt,
  FaGlobe,
  FaBookOpen,
  FaApple,
  FaAndroid,
  FaChrome,
  FaTelegram,
  FaPlay,
  FaHeadset,
  FaWhatsapp,
  FaCog,
  FaShoppingCart,
} from "react-icons/fa";
import { SiAparat } from "react-icons/si";
import { FaEnvelope } from "react-icons/fa";
import { BsHeadset } from "react-icons/bs";
import logo from "../src/logo.png";
import parlarLogo from "../src/parlar.png";
import line from "../src/line.png";
import elehome from "../src/elehome.png";
import powered from "../src/powered by.png";
import eleviaIcon from "../src/elevia icon.svg";

function App() {
  const [urlParams, setUrlParams] = useState({});
  const [brand, setBrand] = useState('elevia');
  const [newsletterChecked, setNewsletterChecked] = useState(false);
  const [formData, setFormData] = useState({ name: '', phone_number: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const pid = params.get('pid');
    const did = params.get('did');
    const name = params.get('name');
    const companyParam = params.get('company');
    
    if (pid && did) {
      setUrlParams({ pid, did, name });
    }
    
    if (companyParam) {
      setBrand(companyParam);
    }
    
    // Set body background color based on company
    const bodyColor = companyParam === 'parlar' ? '#111e72' : '#ec1c24';
    document.body.style.backgroundColor = bodyColor;
  }, []);

  const getDeviceControlUrl = () => {
    if (urlParams.pid && urlParams.did) {
      return `https://web.elehome.ir/guest-landing/${urlParams.pid}/${urlParams.did}`;
    }
    return 'https://web.elehome.ir';
  };
  const getBrandLogo = () => {
    return brand === 'parlar' ? parlarLogo : logo;
  };

  const getBrandColor = () => {
    return brand === 'parlar' ? '#111e72' : '#ec1c24';
  };

  const getBrandTitle = () => {
    return brand === 'parlar' ? 'پــــــارلار، طلـــــوع نـــــــوآوری…​' : 'زندگی هوشمندانه در جریانه';
  };

  const getWebsiteLink = () => {
    return brand === 'parlar' ? 'https://parlar.ir' : 'https://elevia.ir';
  };

  const getWebsiteText = () => {
    return brand === 'parlar' ? 'وب سایت پارلار' : 'وب سایت الویا';
  };

  const getCatalogLink = () => {
    return brand === 'parlar' ? 'https://catalog.parlar.ir/' : 'https://elevia.ir/elevia.pdf';
  };

  const getCatalogText = () => {
    return brand === 'parlar' ? 'کاتالوگ محصولات پارلار' : 'دانلود کاتالوگ دیجیتال';
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const response = await fetch('https://websites-backend.parlarelectronics.com/items/expo', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          phone_number: formData.phone_number,
          agent: navigator.userAgent
        })
      });
      
      if (response.ok) {
        setShowSuccessMessage(true);
        setFormData({ name: '', phone_number: '' });
        setNewsletterChecked(false);
      } else {
        const errorData = await response.json();
        
        // Check if it's a "record not unique" error
        if (errorData.errors && errorData.errors.some(error => 
          error.extensions && error.extensions.code === 'RECORD_NOT_UNIQUE'
        )) {
          setIsSubscribed(true);
          setFormData({ name: '', phone_number: '' });
          setNewsletterChecked(false);
        } else {
          alert('خطا در عضویت. لطفاً دوباره تلاش کنید.');
        }
      }
    } catch (error) {
      alert('خطا در ارسال اطلاعات. لطفاً دوباره تلاش کنید.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="App" style={{ backgroundColor: getBrandColor() }}>
      <header className="App-header">
        <div></div>

        <div className="main-container">
          <div className="header-section">
            <img src={getBrandLogo()} alt={brand === 'parlar' ? 'Parlar Logo' : 'Elevia Logo'} />
            <h2 className="main-title">{getBrandTitle()}</h2>
            
            {urlParams.pid && urlParams.did && (
              <a 
                href={getDeviceControlUrl()} 
                target="_blank" 
                rel="noopener noreferrer"
                className="device-control-button"
                style={{ 
                  borderColor: getBrandColor(),
                  color: getBrandColor()
                }}
              >
                <span>کنترل هوشمند دستگاه</span>
                {urlParams.name && <span className="device-name" style={{ backgroundColor: getBrandColor() }}>{urlParams.name}</span>}
              </a>
            )}
            
            <div className="newsletter-section">
              {showSuccessMessage ? (
                <div className="newsletter-success-message">
                  <span>شما با موفقیت عضو خبرنامه شده اید</span>
                </div>
              ) : isSubscribed ? (
                <div 
                  className="newsletter-success"
                  style={{ backgroundColor: getBrandColor() }}
                >
                  <span>شما عضو خبرنامه می باشید</span>
                </div>
              ) : (
                <label 
                  className="newsletter-checkbox"
                  style={{ backgroundColor: getBrandColor() }}
                >
                  <input
                    type="checkbox"
                    checked={newsletterChecked}
                    onChange={(e) => setNewsletterChecked(e.target.checked)}
                  />
                  <span>عضویت در خبرنامه</span>
                </label>
              )}
              
              {newsletterChecked && (
                <form onSubmit={handleFormSubmit} className="newsletter-form">
                  <input
                    type="text"
                    name="name"
                    placeholder="نام"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="newsletter-input"
                  />
                  <input
                    type="tel"
                    name="phone_number"
                    placeholder="شماره موبایل"
                    value={formData.phone_number}
                    onChange={handleInputChange}
                    required
                    className="newsletter-input"
                  />
                  <button type="submit" disabled={isSubmitting} className="newsletter-submit">
                    {isSubmitting ? 'در حال ارسال...' : 'عضویت'}
                  </button>
                </form>
              )}
            </div>
          </div>

          <div className="links-section">
            <img src={line} alt="divider" />
            <a href={getWebsiteLink()} target="_blank" rel="noopener noreferrer" className="app-link">
              <div className="app-link-icon">
                <FaGlobe size={24} color="white" />
              </div>
              <div className="app-link-text">
                <span>{getWebsiteText()}</span>
              </div>
            </a>
            <img src={line} alt="divider" />
            <a
              href={getCatalogLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="app-link"
            >
              <div className="app-link-icon">
                <FaBookOpen size={24} color="white" />
              </div>
              <div className="app-link-text">
                <span>{getCatalogText()}</span>
              </div>
            </a>
            <img src={line} alt="divider" />
            <a href="https://elesell.ir" target="_blank" rel="noopener noreferrer" className="app-link">
              <div className="app-link-icon">
                <FaShoppingCart size={24} color="white" />
              </div>
              <div className="app-link-text">
                <span>فروشگاه آنلاین ال سل</span>
              </div>
            </a>
            <img src={line} alt="divider" />
          </div>

          <div className="apps-section">
            <img src={elehome} alt="Elehome" />
            <div className="download-buttons-container">
              <a 
                href="https://web.elehome.ir" 
                target="_blank" 
                rel="noopener noreferrer"
                className="download-button"
              >
                <FaApple size={24} />
                <span>IOS</span>
              </a>
              <a 
                href="https://cafebazaar.ir/app/ir.elehome" 
                target="_blank" 
                rel="noopener noreferrer"
                className="download-button"
              >
                <FaAndroid size={24} />
                <span>ANDROID</span>
              </a>
              <a 
                href="https://web.elehome.ir" 
                target="_blank" 
                rel="noopener noreferrer"
                className="download-button"
              >
                <FaChrome size={24} />
                <span>Web App</span>
              </a>
            </div>
            {/* <p className="platform-text">دسترسی به پلتفرم خانه هوشمند</p> */}
          </div>

          <div className="footer-section">
            <div className="social-media">
              <a href="mailto:info@elevia.ir" target="_blank" rel="noopener noreferrer" className="social-link">
                <FaEnvelope className="social-icon" />
              </a>
              <a href="https://elevia.ir" target="_blank" rel="noopener noreferrer" className="social-link">
                <BsHeadset className="social-icon" />
              </a>
              <a href="https://www.aparat.com/v/f90Ns" target="_blank" rel="noopener noreferrer" className="social-link">
                <SiAparat className="social-icon" />
              </a>
              <a href="https://www.instagram.com/elevia_smartlife" target="_blank" rel="noopener noreferrer" className="social-link">
                <FaInstagram className="social-icon" />
              </a>
            </div>
            <div className="footer-row">
              <div className="platform-section">
                <p className="platform-text">
                  {/* <img src={eleviaIcon} alt="Elevia" className="platform-icon" /> */}
                  <a href="https://parlar.ir/video.mp4" target="_blank" style={{textDecoration: "none", color: "white"}}>معرفی کارخانه</a>
                </p>
                <a href="https://wa.me/989912584968" target="_blank" rel="noopener noreferrer" className="whatsapp-link">
                  {/* <FaWhatsapp /> مشاوره واتساپ */}
                   مشاوره واتساپ
                </a>
              </div>
              <div className="phone-consultation">
                <div className="phone-numbers">
                  <p><FaPhoneAlt /> 04151613103</p>
                  <p><FaPhoneAlt /> 04151613102</p>
                </div>
              </div>
            </div>
            <img src={powered} alt="Powered by" />
          </div>
        </div>

        <div></div>
      </header>
    </div>
  );
}

export default App;
